export const createNotification = (item = {}) => {
    return {
        id: item.id,
        message: item.message ?? '',
        duration: item.duration ?? 5,
        placement: item.placement ?? 'top',
        icon: item.icon,
        key: item.key ?? '',
        status: item.status ?? 'info',
        navigate: item.navigate || false,
        create_date: item.create_date ?? undefined,
        // read: false,
    };
};
